import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  //   Text,
  VStack,
  //   Box,
  //   useToast,
  FormControl,
  // InputGroup,
  // InputRightElement,
} from "@chakra-ui/react";

// import Input from "../Input/Input";
import Button from "../Button/Button";
import Input from "../Input/Input";
// import { useHistory } from "react-router-dom";

import { useMemo, useCallback, useState } from "react";
// import { VisibilityOffRounded, VisibilityRounded } from "@material-ui/icons";

export default function PartnersFilter(props) {
  const { isOpen, onClose, onFilter } = props;

  //   const pinMax = 6;

  //   const history = useHistory();
  //   const toast = useToast();

  const [state, _setState] = useState();

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  const handleFilter = () => {
    onClose && onClose();
    onFilter && onFilter({ ...state });
  };

  const isDisabled = useMemo(
    () => !(state?.beforeDate && state?.afterDate),
    [state]
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton top="26px" right="40px" />
        <ModalHeader textAlign="center" mt="12px !important">
          Filter
        </ModalHeader>
        <ModalBody px="40px">
          <VStack w="100%" alignItems="center" gridGap="10px">
            {/* <HStack mt="12px" flexDir={["column", "column", "row"]}> */}
            <FormControl>
              <Input
                label="Start Date"
                minH="40px"
                maxH="40px"
                borderColor="#EFF0F6"
                bg="white"
                type="date"
                placeholder="Start Date"
                value={state?.afterDate ?? ""}
                onChange={(e) => setState({ afterDate: e.target.value })}
              />
            </FormControl>
            <FormControl
              mt={["14px !important", "14px !important", "0 !important"]}
            >
              <Input
                label="End Date"
                minH="40px"
                maxH="40px"
                borderColor="#EFF0F6"
                bg="white"
                type="date"
                placeholder="End Date"
                value={state?.beforeDate ?? ""}
                onChange={(e) => setState({ beforeDate: e.target.value })}
              />
            </FormControl>
            {/* </HStack> */}
          </VStack>
        </ModalBody>

        <ModalFooter justifyContent="center" pt="30px" pb="60px">
          <Button
            // isLoading={isLoading}
            disabled={isDisabled}
            onClick={handleFilter}
            fontWeight="400"
            minH="64px"
            minW="210px"
          >
            Filter
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
